import React, { useEffect } from "react";
import { SearchId } from "../../services/SearchId";
import { useLiff } from "react-liff";
import { useNavigate } from "react-router-dom";
import TopLogo from "../../components/layout/TopLogo";
import qrcode from "../../assets/images/icon/qrcode.svg";
import qrcodeWhite from "../../assets/images/icon/qrcode-white.svg"
import PrimaryButton from "../../components/button/PrimaryButton";
import PrimaryGreenButton from "../../components/button/PrimaryGreenButton";

import dogimage from "../../assets/images/image-dog.png"
import catimage from "../../assets/images/image-cat.png"

export default function QrCodeSelect() {
    // api state

    const navigate = useNavigate();

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;
    

    useEffect(() => {
        getSearchId();
    }, []);


    async function getSearchId() {
        return await SearchId({
            params: { lineId: lineId || null },
        })
            .then(async (response) => {
                console.log('response.data.body.employeeId >>' + response.data.body.employeeId )
                if (!response.data.body.employeeId) {
                      window.location.replace("/register");
                } 
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const exitLineApp = () => {
        liff.closeWindow();
    };

    return (
        <div id="generate-qr-code-page" className="page-f-screen">
            <TopLogo />
            <div
                id="generate-qr-code"
                className="mt-[0px] pt-[24px] pb-[36px] px-[13px] flex-1"
            >
                <div className="relative round-[4px] h-full py-[24px] flex flex-col justify-center">
                    <div className="flex-1">
                        <div className="mb-[24px]">
                            <img className="w-[30px] mx-auto mb-[10px]" src={qrcode} alt="" />
                            <p className="text-[36px] text-darkGray text-center leading-[100%]">
                                สร้าง QR Code เก็บคะแนน
                            </p>
                            <p className="text-[20px] text-darkGray text-center leading-[100%]">
                                วิธีสแกน ให้ลูกค้ากดที่เมนู สะสมCoin&แลกของรางวัล
                            </p>
                        </div>
                        {/* {QRCodeValue} */}
                        <div className="mb-[24px] flex gap-[10px] items-center">
                            <div className="justify-center items-center border-[1px] border-lightGray3 rounded-[28px] h-[250px] w-full"
                                style={{ backgroundColor: '#EAF1FC' }}>
                                <p className="text-[30px] mt-[15px] text-blue text-center leading-[100%]">
                                    สำหรับน้องหมา
                                </p>
                                <img className="w-[130px] mx-auto mb-[10px]" src={dogimage} alt="" />
                                <div className="flex justify-center mt-[5px]">
                                    <PrimaryButton onClick={() => {
                                        navigate("/generate-qr-code?type=dog");
                                    }}>
                                        <img className="w-[15px]" src={qrcodeWhite} alt="" />
                                        สร้าง QR Code
                                    </PrimaryButton>
                                </div>
                            </div>
                            <div className="justify-center items-center border-[1px] border-lightGray3 rounded-[28px] h-[250px] w-full"
                                style={{ backgroundColor: '#EAF6EF' }}>
                                <p className="text-[30px] mt-[15px] text-green text-center leading-[100%]">
                                    สำหรับน้องแมว
                                </p>
                                <img className="w-[130px] mx-auto mb-[10px]" src={catimage} alt="" />
                                <div className="flex justify-center mt-[5px]">
                                    <PrimaryGreenButton onClick={() => {
                                        navigate("/generate-qr-code?type=cat");
                                    }}>
                                        <img className="w-[15px]" src={qrcodeWhite} alt="" />
                                        สร้าง QR Code
                                    </PrimaryGreenButton>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className="flex justify-center mx-[20px]">
                        <button
                            onClick={exitLineApp}
                            className="flex justify-center items-center border-[1px] border-blue rounded-[28px] w-full gap-[10px] py-[8px]"
                        >
                            <p className="text-[24px] text-blue text-center">ย้อนกลับ</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
